import {useMutation, useQueryClient} from "react-query";
import {useFormik} from "formik";
import useFetchModuleEntries from "../../hooks/useFetchModuleEntries";
import {useEffect} from "react";
import api from "../../services/api";
import {useParams} from "react-router-dom";
import useFetchUser from "../../hooks/useFetchUser";

const pollMutation = ({timing,...data}) => {
  const formData = new FormData();

  Object.keys(data).forEach(key => {
    if(Array.isArray(data[key])) {
      data[key].forEach((v, index) => {
        formData.set(`${key}[${index}]`, v);
      })
    }
    else {
      formData.set(key, data[key]);
    }
  });

  return api.post(`/timings/${timing}/module-entries`, formData).then(response => response.data && response.data.data);
};

const useFetchPoll = (module) => {
  const { timing } = useParams();
  const {data:user} = useFetchUser();
  const queryClient = useQueryClient();

  console.log(module);

  const query = useFetchModuleEntries(module?.id, user?.id, {
    enabled: !!(module?.id && user?.id),
  });

  const mutation = useMutation(pollMutation, {
    onSuccess: async (data) => {
      await queryClient.setQueryData(['module-entries', module?.id, user?.id], (old) => {
        console.log(old, data);

        return [data, ...(old || [])];
      })

      return true;
    }
  });

  const formik = useFormik({
    initialValues: {
      timing,
      module: module?.id,
    },
    validate: (values) => {
      mutation.reset();

      return {};
    },
    onSubmit: mutation.mutateAsync,
  });

  useEffect(() => {
    formik.resetForm();
    formik.setFieldValue('module', module?.id);

    Object.values(module?.config?.questions || {}).forEach(item => {
      formik.setFieldValue(item.id, item.default || '');
    });
  }, [module?.id]);

  return {
    query,
    formik,
    mutation,
  };
};

export default useFetchPoll;
